import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilterSelected = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 13,
	viewBox: "0 0 14 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.3374 1C8.12142 1.45464 8.00049 1.96319 8.00049 2.5C8.00049 3.87832 8.79754 5.06989 9.95557 5.64062C8.96782 6.80519 8.17906 7.73407 8.16553 7.75V12.25C8.16553 12.6623 7.79667 12.9996 7.34619 13H5.70654C5.25573 13 4.88721 12.6625 4.88721 12.25V7.75C4.88721 7.75 1.8291 4.14958 0.17334 2.20703C-0.24399 1.71205 0.141691 1 0.821777 1H8.3374ZM11.5005 0C12.881 0.00026385 14.0005 1.11945 14.0005 2.5C14.0005 3.88055 12.881 4.99974 11.5005 5C10.1198 5 9.00049 3.88071 9.00049 2.5C9.00049 1.11929 10.1198 0 11.5005 0Z",
		fill: "currentColor"
	})
});
export default SvgFilterSelected;
